(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["viviland-cozy-season"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalizeSize = value => value.trim().replace(/\s*[（(].*$/, '').replace(/\s+/g, ' ').toLowerCase();
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-cc-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-cc-card]'));
    const sizeLabels = new Map();
    const records = cards.map(card => {
      const sizes = Array.from(card.querySelectorAll('[data-cc-size]')).map(el => {
        const normalized = normalizeSize(el.dataset.ccSize);
        const label = normalized.replace(/\b\w/g, char => char.toUpperCase()).replace(/Xl/g, 'XL');
        el.textContent = label;
        sizeLabels.set(normalized, label);
        return normalized;
      });
      return {card, sizes: [...new Set(sizes)], group:card.dataset.group, price:Number(card.dataset.price), index:Number(card.dataset.index), title:card.dataset.title};
    });
    const filters = root.querySelector('[data-cc-filters]');
    const media = window.matchMedia('(max-width:700px)');
    filters.open = !media.matches;
    media.addEventListener('change', event => filters.open = !event.matches);
    if (root.hasAttribute('data-collection-catalogue')) {
      const filterForm = root.querySelector('[data-cc-collection-form]');
      const lower = filterForm.querySelector('[data-cc-price-min]');
      const upper = filterForm.querySelector('[data-cc-price-max]');
      const validateRange = () => {
        if (lower && upper) upper.setCustomValidity(lower.value !== '' && upper.value !== '' && Number(lower.value) > Number(upper.value) ? filterForm.dataset.priceError : '');
      };
      filterForm.addEventListener('input', validateRange);
      root.addEventListener('change', event => {
        if (event.target.form === filterForm) { validateRange(); filterForm.requestSubmit(); }
      });
      filterForm.addEventListener('submit', validateRange);
    } else {
    const sizeContainer = root.querySelector('[data-cc-size-options]');
    const sizeOrder = ['twin','twin xl','full','queen','king','california king'];
    [...sizeLabels].sort((a,b) => (sizeOrder.includes(a[0]) ? sizeOrder.indexOf(a[0]) : 99) - (sizeOrder.includes(b[0]) ? sizeOrder.indexOf(b[0]) : 99) || a[0].localeCompare(b[0])).forEach(([value,label]) => {
      const row = document.createElement('label'); row.className = 'cc-option';
      const input = document.createElement('input'); input.type = 'checkbox'; input.name = 'cc-size'; input.value = value;
      const text = document.createElement('span'); text.textContent = label;
      const count = document.createElement('span'); count.className = 'cc-option-count'; count.textContent = `(${records.filter(item => item.sizes.includes(value)).length})`;
      row.append(input,text,count); sizeContainer.append(row);
    });
    root.querySelector('[data-cc-size-group]').hidden = sizeLabels.size === 0;
    const min = root.querySelector('[data-cc-min]');
    const max = root.querySelector('[data-cc-max]');
    const sort = root.querySelector('[data-cc-sort]');
    const update = () => {
      const groups = Array.from(root.querySelectorAll('[name="cc-type"]:checked')).map(input => input.value);
      const sizes = Array.from(root.querySelectorAll('[name="cc-size"]:checked')).map(input => input.value);
      const lower = min.value === '' ? 0 : Math.max(0,Number(min.value)*100);
      const upper = max.value === '' ? Infinity : Math.max(0,Number(max.value)*100);
      let total = 0;
      const ordered = [...records].sort((a,b) => sort.value === 'low' ? a.price-b.price || a.index-b.index : sort.value === 'high' ? b.price-a.price || a.index-b.index : sort.value === 'az' ? a.title.localeCompare(b.title) : a.index-b.index);
      ordered.forEach(item => {
        const match = (!groups.length || groups.includes(item.group)) && (!sizes.length || sizes.some(size => item.sizes.includes(size))) && item.price >= lower && item.price <= upper;
        item.card.hidden = !match; if (match) total++; grid.append(item.card);
      });
      root.querySelector('[data-cc-count]').textContent = total;
      root.querySelector('[data-cc-empty]').hidden = total !== 0;
    };
    root.addEventListener('change', event => { if (!event.target.closest('[data-cc-dialog]')) update(); });
    min.addEventListener('input',update); max.addEventListener('input',update);
    root.querySelectorAll('[data-cc-reset]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);
      min.value = ''; max.value = ''; update();
    }));
    filters.hidden = false; root.querySelector('[data-cc-toolbar]').hidden = false;
    update();
    }

  };
  document.querySelectorAll('[data-cozy-catalogue]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-cozy-catalogue]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viviland-fall-event"] && !Shopify.designMode) return;
  try {
    
function initFallEvents() {
  document.querySelectorAll('[data-fall-event]').forEach(root => {
    if (root.dataset.feReady) return;
    root.dataset.feReady = 'true';
    const controls = root.querySelector('[data-fe-controls]');
    const grid = root.querySelector('[data-fe-grid]');
    const cards = Array.from(grid.querySelectorAll('[data-fe-card]'));
    const filters = Array.from(root.querySelectorAll('[data-fe-filter]'));
    const sort = root.querySelector('[data-fe-sort]');
    const wrap = root.querySelector('[data-fe-sort-wrap]');
    const trigger = root.querySelector('[data-fe-sort-trigger]');
    const value = root.querySelector('[data-fe-sort-value]');
    const list = root.querySelector('[data-fe-sort-options]');
    const controller = new AbortController();
    const listen = (target, event, handler) => target.addEventListener(event, handler, { signal: controller.signal });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let selected = 'all';
    let gridAnimation;
    let activeIndex = sort.selectedIndex;
    let search = '';
    let searchTimer;
    const options = Array.from(sort.options, (option, index) => {
      const item = document.createElement('li');
      item.className = 'fe-sort-option';
      item.id = `${list.id}-${index}`;
      item.setAttribute('role', 'option');
      item.dataset.value = option.value;
      const label = document.createElement('span');
      label.textContent = option.text;
      item.appendChild(label);
      const check = root.querySelector('.fe-filter-mark svg').cloneNode(true);
      check.setAttribute('aria-hidden', 'true');
      item.appendChild(check);
      list.appendChild(item);
      return item;
    });
    const syncSort = () => {
      value.textContent = sort.options[sort.selectedIndex].text;
      options.forEach(item => item.setAttribute('aria-selected', String(item.dataset.value === sort.value)));
    };
    const update = (animate = false) => {
      const visible = cards.filter(card => selected === 'all' || card.dataset.group === selected);
      cards.forEach(card => { card.hidden = !visible.includes(card); });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.feFilter === selected)));
      const ordered = [...cards].sort((a, b) => sort.value === 'featured' ? Number(a.dataset.index) - Number(b.dataset.index) : (Number(a.dataset.price) - Number(b.dataset.price)) * (sort.value === 'high' ? -1 : 1) || Number(a.dataset.index) - Number(b.dataset.index));
      ordered.forEach(card => grid.appendChild(card));
      root.querySelector('[data-fe-number]').textContent = visible.length;
      syncSort();
      if (gridAnimation) gridAnimation.cancel();
      if (animate && !reducedMotion.matches && grid.animate) {
        gridAnimation = grid.animate([{ opacity: .55, transform: 'translateY(5px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 200, easing: 'ease-out' });
      }
    };
    const setActive = index => {
      activeIndex = Math.max(0, Math.min(options.length - 1, index));
      options.forEach((item, i) => { item.dataset.active = String(i === activeIndex); });
      trigger.setAttribute('aria-activedescendant', options[activeIndex].id);
    };
    const placeList = () => {
      if (list.hidden) return;
      const rect = trigger.getBoundingClientRect();
      const height = list.offsetHeight;
      list.dataset.side = window.innerHeight - rect.bottom < height + 24 && rect.top > height + 24 ? 'above' : 'below';
    };
    const open = () => {
      list.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setActive(sort.selectedIndex);
      placeList();
    };
    const close = () => {
      list.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.removeAttribute('aria-activedescendant');
      search = '';
      clearTimeout(searchTimer);
    };
    const choose = index => {
      const nextValue = options[index].dataset.value;
      close();
      if (sort.value !== nextValue) {
        sort.value = nextValue;
        sort.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    filters.forEach(button => listen(button, 'click', () => {
      close();
      if (selected === button.dataset.feFilter) return;
      selected = button.dataset.feFilter;
      update(true);
    }));
    listen(sort, 'change', () => update(true));
    listen(trigger, 'click', () => { if (list.hidden) open(); else close(); });
    listen(trigger, 'keydown', event => {
      const { key } = event;
      if (key === 'ArrowDown' || key === 'ArrowUp') {
        event.preventDefault();
        if (list.hidden) open(); else setActive(activeIndex + (key === 'ArrowDown' ? 1 : -1));
      } else if (key === 'Home' || key === 'End') {
        event.preventDefault();
        if (list.hidden) open();
        setActive(key === 'Home' ? 0 : options.length - 1);
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        if (list.hidden) open(); else choose(activeIndex);
      } else if (key === 'Escape' && !list.hidden) {
        event.preventDefault();
        event.stopPropagation();
        close();
      } else if (key === 'Tab') {
        close();
      } else if (key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        event.preventDefault();
        if (list.hidden) open();
        clearTimeout(searchTimer);
        search += key.toLowerCase();
        let match = options.findIndex(item => item.textContent.toLowerCase().startsWith(search));
        if (match < 0) {
          search = key.toLowerCase();
          match = options.findIndex(item => item.textContent.toLowerCase().startsWith(search));
        }
        if (match >= 0) setActive(match);
        searchTimer = setTimeout(() => { search = ''; }, 700);
      }
    });
    options.forEach((item, index) => {
      listen(item, 'pointerdown', event => { if (event.button === 0) event.preventDefault(); });
      listen(item, 'pointermove', event => { if (event.pointerType === 'mouse') setActive(index); });
      listen(item, 'click', () => { choose(index); trigger.focus({ preventScroll: true }); });
    });
    listen(document, 'pointerdown', event => { if (!wrap.contains(event.target)) close(); });
    listen(wrap, 'focusout', event => { if (!wrap.contains(event.relatedTarget)) close(); });
    listen(window, 'resize', placeList);
    listen(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      clearTimeout(searchTimer);
      if (gridAnimation) gridAnimation.cancel();
      controller.abort();
    });
    update();
    sort.hidden = true;
    wrap.querySelector('label').htmlFor = trigger.id;
    trigger.hidden = false;
    controls.hidden = false;
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFallEvents); else initFallEvents();
document.addEventListener('shopify:section:load', initFallEvents);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viviland-home-collections"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('viviland-category-carousel')) {
  customElements.define('viviland-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.disconnect?.();
      const grid = this.querySelector('.hc-category-grid');
      const bar = this.querySelector('.hc-category-scrollbar');
      const controls = this.querySelector('.hc-category-controls');
      const previous = this.querySelector('[data-category-previous]');
      const next = this.querySelector('[data-category-next]');
      if (!grid || !bar || !controls || !previous || !next) return;
      const events = new AbortController();
      const options = { signal: events.signal };
      let frame = 0;
      let scrubbing = false;
      const behavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      const update = () => {
        frame = 0;
        const overflow = Math.max(0, grid.scrollWidth - grid.clientWidth);
        const left = Math.max(0, grid.scrollLeft);
        controls.hidden = bar.hidden = overflow < 2;
        grid.classList.toggle('has-category-scrollbar', overflow >= 2);
        previous.disabled = left < 2;
        next.disabled = left >= overflow - 2;
        bar.style.setProperty('--category-thumb-width', `${bar.clientWidth * Math.min(1, grid.clientWidth / grid.scrollWidth)}px`);
        if (!scrubbing) bar.value = String(overflow ? Math.min(100, left / overflow * 100) : 0);
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const step = (direction, single = false) => {
        const first = grid.querySelector('.hc-category');
        if (!first) return;
        const size = first.getBoundingClientRect().width + parseFloat(getComputedStyle(grid).columnGap);
        const count = single ? 1 : Math.max(1, Math.floor(grid.clientWidth / size));
        grid.scrollBy({ left: direction * size * count, behavior: behavior() });
      };
      const finish = () => {
        scrubbing = false;
        grid.classList.remove('is-category-scrubbing');
        schedule();
      };
      previous.addEventListener('click', () => step(-1), options);
      next.addEventListener('click', () => step(1), options);
      grid.addEventListener('scroll', schedule, { passive: true, ...options });
      grid.addEventListener('keydown', (event) => {
        if (event.target !== grid) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          grid.scrollTo({ left: event.key === 'Home' ? 0 : grid.scrollWidth, behavior: behavior() });
        }
      }, options);
      bar.addEventListener('pointerdown', () => {
        scrubbing = true;
        grid.classList.add('is-category-scrubbing');
      }, options);
      bar.addEventListener('input', () => {
        grid.scrollTo({ left: (grid.scrollWidth - grid.clientWidth) * Number(bar.value) / 100, behavior: 'instant' });
      }, options);
      bar.addEventListener('keydown', (event) => {
        if (['ArrowLeft', 'ArrowDown', 'ArrowRight', 'ArrowUp', 'PageDown', 'PageUp'].includes(event.key)) {
          event.preventDefault();
          const direction = ['ArrowLeft', 'ArrowDown', 'PageDown'].includes(event.key) ? -1 : 1;
          step(direction, !event.key.startsWith('Page'));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          grid.scrollTo({ left: event.key === 'Home' ? 0 : grid.scrollWidth, behavior: behavior() });
        }
      }, options);
      bar.addEventListener('change', finish, options);
      window.addEventListener('pointerup', finish, options);
      window.addEventListener('pointercancel', finish, options);
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.hc-category');
        if (card) grid.scrollTo({ left: card.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft - 3, behavior: 'instant' });
      }, options);
      const observer = new ResizeObserver(schedule);
      observer.observe(grid);
      this.disconnect = () => { events.abort(); observer.disconnect(); cancelAnimationFrame(frame); };
      update();
    }
    disconnectedCallback() { this.disconnect?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viviland-home-header"]) return;
  try {
    
(() => {
  let dispose;
  function mountMobileHeader() {
    dispose?.();
    const header = document.querySelector('#shopify-section-viviland-home-header > .header');
    if (!header) return;
    const mobile = matchMedia('(max-width: 700px)');
    const events = new AbortController();
    let frame = 0;
    function update() {
      frame = 0;
      if (!mobile.matches) {
        header.classList.remove('is-mobile-floating');
        // Keep the current header geometry while a search or bag modal locks scrolling.
        if (document.body.style.position === 'fixed') return;
        const compact = header.classList.contains('is-desktop-compact');
        header.classList.toggle('is-desktop-compact', window.scrollY > (compact ? 20 : 64));
        return;
      }
      header.classList.remove('is-desktop-compact');
      if (document.body.style.position === 'fixed') return;
      const floating = header.classList.contains('is-mobile-floating');
      header.classList.toggle('is-mobile-floating', window.scrollY > (floating ? 16 : 40));
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true, signal: events.signal });
    window.addEventListener('pageshow', schedule, { signal: events.signal });
    mobile.addEventListener('change', schedule, { signal: events.signal });
    dispose = () => {
      events.abort();
      cancelAnimationFrame(frame);
    };
    update();
  }
  mountMobileHeader();
  document.addEventListener('shopify:section:load', mountMobileHeader);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.id === 'shopify-section-viviland-home-header') dispose?.();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viviland-home-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__vvOffers) return;
  window.__vvOffers = true;
  let opener, saved;
  const getDialog = () => document.getElementById('vv-offers-dialog');
  function select(dialog, name, focus = false) {
    const tabs = [...dialog.querySelectorAll('[data-offers-tab]')];
    const active = tabs.find(tab => tab.dataset.offersTab === name) || tabs[0];
    tabs.forEach(tab => {const selected = tab === active; tab.setAttribute('aria-selected', String(selected));tab.tabIndex = selected ? 0 : -1;document.getElementById(tab.getAttribute('aria-controls')).hidden = !selected;});
    dialog.querySelector('.vv-offers-scroll').scrollTop = 0;
    if (focus) active.focus();
  }
  function lock() {
    const header = document.querySelector('[data-vv-header],#shopify-section-viviland-home-header > .header');
    const section = header?.closest('.shopify-section');
    saved = {y:scrollY,overflow:document.documentElement.style.overflow,body:{},header,headerStyle:{},section,height:section?.style.height};
    for (const key of ['position','top','left','right','width','overflow']) saved.body[key] = document.body.style[key];
    if(header && section){for(const key of ['position','top','left','width','margin','transition']) saved.headerStyle[key]=header.style[key];const rect=header.getBoundingClientRect();section.style.height=`${section.offsetHeight}px`;Object.assign(header.style,{position:'fixed',top:`${rect.top}px`,left:`${rect.left}px`,width:`${rect.width}px`,margin:'0',transition:'none'});}
    Object.assign(document.body.style,{position:'fixed',top:`-${saved.y}px`,left:'0',right:'0',width:'100%',overflow:'hidden'});
    document.documentElement.style.overflow='hidden';
  }
  function unlock(){
    if(!saved)return;
    const state=saved;saved=null;const behavior=document.documentElement.style.scrollBehavior;document.documentElement.style.scrollBehavior='auto';
    Object.assign(document.body.style,state.body);document.documentElement.style.overflow=state.overflow;
    if(state.header){Object.assign(state.header.style,state.headerStyle);state.section.style.height=state.height;}
    window.scrollTo(0,state.y);document.documentElement.style.scrollBehavior=behavior;
  }
  function close(dialog){dialog.close();unlock();document.querySelectorAll('[data-vv-offers-open]').forEach(node=>node.setAttribute('aria-expanded','false'));if(opener?.isConnected)opener.focus({preventScroll:true});}
  function bind(dialog){
    if(dialog.dataset.bound)return;dialog.dataset.bound='true';
    dialog.addEventListener('cancel',event=>{event.preventDefault();close(dialog);});
    dialog.addEventListener('close',()=>{unlock();document.querySelectorAll('[data-vv-offers-open]').forEach(node=>node.setAttribute('aria-expanded','false'));});
    dialog.addEventListener('keydown',event=>{const current=event.target.closest('[data-offers-tab]');if(!current)return;const tabs=[...dialog.querySelectorAll('[data-offers-tab]')];let index=tabs.indexOf(current);if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;event.preventDefault();select(dialog,tabs[index].dataset.offersTab,true);});
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close(dialog);}});
  }
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const dialog=getDialog();if(!dialog)return;
    const trigger=event.target.closest('[data-vv-offers-open]');
    if(trigger){if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button!==0)return;event.preventDefault();if(dialog.open)return;for(const other of document.querySelectorAll('dialog[open]')){const button=other.querySelector('.menu-close,.bag-close,[data-vv-close]');if(button)button.click();else other.close();}opener=trigger;bind(dialog);select(dialog,trigger.dataset.vvOffersOpen||'first');lock();dialog.showModal();trigger.setAttribute('aria-expanded','true');return;}
    if(!dialog.contains(event.target))return;
    if(event.target.closest('[data-vv-close]'))close(dialog);
    const tab=event.target.closest('[data-offers-tab]');if(tab)select(dialog,tab.dataset.offersTab);
    if(event.target.closest('[data-offers-gift-link]')){const gift=document.getElementById('gift');close(dialog);if(gift){event.preventDefault();gift.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});gift.setAttribute('tabindex','-1');gift.focus({preventScroll:true});}}
  });
  window.addEventListener('pagehide',()=>{const dialog=getDialog();if(dialog?.open)close(dialog);});
  document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector('#vv-offers-dialog'))unlock();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viviland-home-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('viviland-home-videos')) {
  customElements.define('viviland-home-videos', class extends HTMLElement {
    connectedCallback() {
      this.cleanup?.();
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const states = new Map();
      const listeners = [];
      const pause = (video, state) => {
        if (!video.paused) { state.automaticPause = true; video.pause(); }
      };
      const sync = () => states.forEach((state, video) => {
        if (state.visible && !document.hidden && state.wantsPlay) video.play().catch(() => {});
        else pause(video, state);
      });
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { states.get(entry.target).visible = entry.isIntersecting && entry.intersectionRatio >= 0.5; });
        sync();
      }, { threshold: [0, 0.5] });
      this.querySelectorAll('video').forEach(video => {
        const state = { visible: false, wantsPlay: !reduced.matches && !navigator.connection?.saveData, automaticPause: false };
        states.set(video, state);
        const onPlay = () => { state.wantsPlay = true; };
        const onPause = () => { if (state.automaticPause) state.automaticPause = false; else state.wantsPlay = false; };
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', onPause);
        listeners.push(() => { video.removeEventListener('play', onPlay); video.removeEventListener('pause', onPause); });
        observer.observe(video);
      });
      const onMotion = () => { if (reduced.matches) { states.forEach(state => { state.wantsPlay = false; }); sync(); } };
      reduced.addEventListener('change', onMotion);
      document.addEventListener('visibilitychange', sync);
      this.cleanup = () => { observer.disconnect(); document.removeEventListener('visibilitychange', sync); reduced.removeEventListener('change', onMotion); listeners.forEach(remove => remove()); states.forEach((state, video) => pause(video, state)); };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
